import { NS_SPROUT_CORE, SproutCoreResources } from '@growtherapy/sprout-ui';

import { NS_SEEDLINGS_CORE, SeedlingsCoreResources } from '@grow-therapy-team/seedling-components';

// Untraced by TurboSnap (see .github/workflows/chromatic.yaml) so design-system bumps don't
// reach preview.tsx through testUtils and trigger a full rebuild. Keep design-system i18n
// imports funneled through this file.
export const externalNamespaces = [NS_SPROUT_CORE, NS_SEEDLINGS_CORE];

export const externalResources = {
  ...SeedlingsCoreResources,
  ...SproutCoreResources,
};
